module.exports = __webpack_public_path__ + "img/product19.10d181f6.png";